interface ApiConstantModel {
  userRegister: string;
  updateUser: string;
  getUser: string;
  getUserById: string;
  getCurrentUserDetails: string;
  changeUserPassword: string;
  getToken: string;
  getRefreshToken: string;
  getHomeCategories: string;
  getHomeProducts: string;
  getHomeProducts1: string;
  getReorderProductsByOrderId: string;
  apiUserAddress: string;
  apiAdminAddress1: string;
  apiAdminAddress: string;
  updateGPSLocation: string;
  updateGPSLocation1: string;
  deleteUserAddress: string;
  getCountries: string;
  getStatesByCounty: string;
  getCitiesByState: string;
  sendForgotPasswordOTP: string;
  sendRegistrationVerficationOTP: string;
  resetPassword: string;
  validateOTP: string;
  setCustomerOrder: string;
  getUserAddressById: string;
  apiAdminAddress2: string;
  getAreaAddressById: string;
  sendUpdateUserOTP: string;
  getAllCourierProviders: string;
  getAllOrder: string;
  getAllPOS: string;
  getInvoiceUsers: string;
  getOrderUserList: string;
  getRouteCodesApi: string;
  saveRouteCodeApi: string;
  deleteRouteCodeApi: string;
  getRouteCodeUsers: string;
  updateUserRouteCode: string;
  assignUserRouteCode: string;
  getMyOrderList: string;
  updateOrderStatus: string;
  generateNewInvoice: string;
  getAllUser: string;
  updateUserDetail: string;
  deleteUserDetail: string;
  setAdminCustomerOrder: string;
  getCustomerAddress: string;
  updateCustomerAddress: string;
  createUser: string;
  getCategory: string;
  getSubCategory: string;
  saveProduct: string;
  updateProduct: string;
  getAllAdminProducts: string;
  getProductPOSQuantity:string;
  deleteProduct: string;
  paymentInvoice: string;
  othersPayment: string;
  changeOrderDeliveryDate: string;
  updatePendingQuantity: string;
  getCountry: string;
  getState: string;
  getCity: string;
  getAllCategory: string;
  getAllSubCategory: string;
  pincodeSearch: string;
  apiuserAddress: string;
  insertProductToInvoice: string;
  createOrderFormCustomer: string;
  createOrderForCustomer: string;
  updateUserAdressEdit: string;
  GetAllAddress: string;
  FilterByUsersAddress: string;
  getNewUsersList: string;
  orderDetails: string;
  getAllOrderByOrderId: string;
  getorderExport: string,
  getOrderExportDetails: string,
  getInvoices: string,
  getInvoicedetails: string,
  FilterAssignRouteCodes: string;
  Assignroutecode2: string;
  NewGetOrderUserList: string;
  canEditAddress: string;
  addArea: string;
  getAllPincodeArea: string;
  searchFilterPincode: string;
  getAllCountryNames: string;
  getStatesByCountryID: string;
  getDistrictsByStateId: string;
  getSubDistrictsByDistrictId: string;
  addNewCountry: string;
  addNewState: string;
  addNewDistrict: string;
  addNewSubDistrict: string;
  GetAllCountries: string;
  GetAllCountriesByFilter: string;
  UpdateCountries: string;
  DeleteCountries: string;
  getMyOrderList1: string;
  getStates: string;
  getAllStatesByfilter: string;
  updateState: string;
  deletestate: string;
  getDistricts: string;
  searchStates: string;
  keywordSearchFilter: string;
  updatedistrict: string;
  deleteDistrict: string;
  searchSubDistricts: string;
  updateAreaPincode: string;
  deleteAreaPincode: string;
  viewAllComplaints: string;
  saveComplaint: string;
  getUserDetailsComplaint: string;
  getComplaintType: string;
  createComplaintType: string;
  deletecomplaintType: string;
  updateComplaintType: string;
  getAllStatus: string;
  createComplaintStatus: string;
  UpdateComplaintStatus: string;
  deletecomplaintStatusId: string;
  deleteComplaintCategory: string;
  updateComplaintCategory: string;
  createComplaintCategory: string;
  getComplaintCategory: string;
  getfilteredComplaints: string;
  getUserInvoices: string;
  getInvoicedproducts: string;
  getProductCategory: string;
  getComplaintStatus: string;
  getAdminUserList: string
  updateComplaint: string;
  getAdminDetailsComplaint: string;
  getUserAllInvoices: string;
  getUserAllInvoicesList: string;
  getCancelledOrders: string;
  getSubDistricts: string;
  getAllSubDistrictsByFilter: string;
  createsubdistrict: string;
  UpdateSubdistrict: string;
  DeleteSubdistrict: string;
  addNewSubDistrict1: string;
  getDirstics: string;
  searchorders: string;
  getOpenOrderUserAddresses: string;
  saveOrderPacking: string;
  getPackingOrderByOrderId: string;
  getOrderCities: string;
  binOrderDetails: string;
  invoiceDetails: string;
  getOrderInvoiceExportdetails: string;
  customerReport: string;
  getcustomerfollowup: string;
  getcallstatus: string;
  savecallhistory: string
  importDriverList: string;
  importDriverList1: string;
  sendWhatsAppTemplateMessage: string;
  getDeliveryOrders: string;
  getDeliveredOrders: string
  cashCollectionReport: string;
  getAllVendors: string;
  createVendor: string,
  updateVendor: string,
  deleteVendor: string,
  getAllProducts: string
  paymentLink: string;
  updateActualpayment: string;
  cashandonline: string;
  getDriversList: string;
  getAdminDeliveryDetails: string;
  getAdminDeliveredDetails: string;
  getOrderAddressInfo: string;
  GetCustomerExecutiveAssignments: string;
  GetCustomerExecutiveList: string;
  UpdateCustomerExecutive: string;
  getDeliveryExecutives: string;
  getpossummary: string;
  getposproducts: string;
  updateposproducts: string;
  remainingposproducts: string;
  addposproducts: string;
  GetOtherPOSStock: string;
  getinwardtypes: string;
  getallvendors: string;
  addinwardproduct: string;
  getadjusttypes: string;
  Addadjustproduct: string;
  getoutwardtypes: string;
  getremainingpos: string;
  addoutwardproduct: string;
  getmovementlog: string;
  addrequest: string;
  getposrequest: string;
  updatepossend: string;
  updateposreject: string;
  getposinwardrequest: string;
  updateposinwardaccept: string;
  updateposinwardreject: string; getGSTSalesReportsList: string;
  getGSTSalesReportsListExports: string;
  getChallanProducts: string;
  createChallan: string;
  GenerateInvoiceDetails: string;
  GetOrderByOrderIdForInvoice: string;
  pullPaymentStatusLogs: string;
  GetCustomerAssignedExecutive: string;
  InvoiceNumber: string;
  OrderInvoiceId: string;
  getUserInvoicesAll: string;
  CreateProductComplaint: string;
  CreateServiceComplaint: string;
  CreateComplaintAction: string;
  GetAllProductComplaints: string;
  GetAllServiceComplaints: string;
  GetAllComplaintActions: string;
  getposproductdetails: string;
  getAllPOSBatch: string;
  GetMUPlantName: string;
  getOilSeedNames: string;
  getAllOilSeedNames: string;
  getVendorNames: string;
  getSeedOilSummaryReport: string;
  getBullsAndOperatorsByPosId: string;
  addOilIntakeLog: string;
  updateOilIntakeLog: string;
  updateOilIntakeLog1: String;
  updateOilIntakeLog2: String;
  GetRolesByUserid: string;
  Assigningtherole: string;
  CreateRole: string;
  GetAllRole: string;
  UpdateRole: string;
  DeleteRole: string;
  UpdateProductComplaintInfo: string;
  UpdateServiceComplaintInfo: string;
  getCustomerDeliveryReport: string;
  getAllBulls: string;
  getAllBullsForPairing: string;
  addBull: string;
  getAllMUPlants: string;
  getAllMUPlants1: string;
  addGaana: string;
  getAllGaanas: string;
  getAllVendor: string;
  getAllDesignations: string;
  addRole: string;
  getAllUsers: string;
  addUser: string;
  getAllOilIntakeLogs: string;
  getAllOilIntakeLog: string;
  GetVendorList: string;
  GetRawMaterialCategory: string;
  GetRawMaterials: string;
  CreateRawMaterialPurchase: string;
  GetRawMaterialMeasurementtype: string;
  GetRawMaterialPurchase: string;
  GetRMCategory: string;
  GetRawmaterialQualitycheck: string;
  SaveRawMaterialQCResult: string;
  getVesselDetails: string;
  GetPaymentOrderStatus: string;
  CreateCustomerServiceComplaint: string;
  GetAllCustServiceComplaints: string;
  UpdateCustServiceComplaintInfo: string;
  deleteDesiriUser: string;
  updateDesiriUser: string;
  getPOSTargetMapping: string;
  updatePOSTargetMappingList: string;
  getPOSTargetMappingMonthList: string;
  searchDelayStatus: string;
  saveDeliveryDelay: string;
  getDelayedOrders: string;
  getAdminDelayedDetails: string;
  GetAllDomain: string;
  GetAllFeatureByDomainID: string;
  GetFeatureByRoleID: string;
  CreateandupdateFeatureMapping: string;
  CreateCustProductComplaint: string;
  GetAllCustProductComplaints: string;
  UpdateCustProductComplaintInfo: string;
  getAllUserSubscriptions: string;
  createUserSubscription: string;
  updateUserSubscription: string;
  pauseUserSubscription: string;
  resumeUserSubscription: string;
  getPOSInventoryReport: string;
  getPOSInventoryExcel: string;
  deleteDesiriBull: string;
  updateDesiriBull: string;
  deleteDesiriGaana: string;
  updateGaanaDetails: string;
  deleteDesiriRole: string;
  updateDesiriRole: string;
  GetDeliveryCashDetails: string;
  GetusersListCashhandover: string;
  addCashHandoverrequest: string;
  GetuserlistSearch: string;
  getAllPosProducts: string;
  getDeliveryAnalysis: string;
  getAssignedOrdersDetails: string;
  getUndeliveredOrdersDetails: string;
  getDeliveredOrdersDetails: string;
  addOilIntakeLog1: string;
  GetMUPlantName1: string;
  GetMUPlantNameById: string;
  getstage2AllOilIntakeLogs: string;
  AddOilProcessingOutputOnly: string;
  getProductwiseOrders: string;
  getTestReportById: string;
  testReportInit: string;
  testReportHeaderById: string;
  testReportHeaderLegacy: string;
  testReportOilTestersByPos: string;
  testReportOilTypes: string;
  testReportBatchesByproduct: string;
  testReportTolerances: string;
  testReportSearch: string;
  testReportTemplate: string;
  testReportCalcPreviewById: string;
  testReportCalcSaveById: string;
  testReportCalcPreviewByProduct: string;
  testReportUpsert: string;
  oilProdMUList: string;
  oilProdOpsByPos: string;
  testReportGetList: string;
  testsFssai: string;
  GetRMInvoiceNumbers: string;
  GetAllRawmaterial: string;
  GetStoreandAcceptedcash: string;
  gethandoverrequests: string;
  acceptcashhandover: string;
  rejectcashhandover: string;
  CustomerExecutiveSalesReport1: string;
  CustomerExecutiveSalesReport2: string;
  CustomerExecutiveSalesReport3: string;
  getOpenOrdersForMap: string;
  getOptimizedRoute: string;
  getDrivers: string;
  createRawMaterial: string;
  UpdateRawMaterial: string;
  deleteRawMaterial: string;
  GetAllRMMeasurementtype: string;
  getAllHandoverRequestsHistory: string;
  CreateInternalComplaint: string;
  CreateInternalComplaintAction: string;
  GetAllInternalComplaints: string;
  UpdateInternalComplaint: string;
  GetAllInternalComplaintAction: string;
  GetAllRMcategories: string;
  DeleteRawMaterialCategory: string;
  UpdateRawMaterialCategory: string;
  CreateRawMaterialCategory: string;
  GetcashReport: string;
  getPreChallanProducts: string;
  GetCETargetMappping: string;
  UpdateTarget: string;
  getAssignedCancelledOrdersDetails: string;
  GetAccountsCashDetails: string;
  getPOSOutwardChallan: string;
  generateOutwardChallan: string
  GetReceivedCashTrace: string;
  GetHandovercashTrace: string;
  CardforCEReport: string;
  CEPerformanceReport1: string;
  GetStatusAnalysis: string;
  GetCEDailyActivityStatusCards: string;
  GetCEDailyActivityTopcard: string;
  getDriverOrdersDailySummary: string;
  GetManufacrturingunitlist: string;
  GetposRawmaterials: string;
  GetRemainingposRawMaterials: string;
  AddposRawmaterials: string;
  UpdateposRawmaterials: string;
  GetalloutwardsourceType: string;
  GetRemainingMFPOS: string;
  GetVendorandInvoiceWiseQty: string;
  AddRawMaterialOutward: string;
  GetRMAdjustSourcetype: string;
  AddRawMaterialAdjust: string;
  GetSummaryCardDetails: string;
  GetDateWisecalldetails: string;
  editOilIntakeLogAPI: string;
  testReportChemsInstrLookup: string;
  GetUnassignedcustomers: string;
  AddRawMaterialRequest: string;
  GetRawMaterialOutwardRequests: string;
  updateRawMaterialRequestSend: string;
  updateRawMaterialRequestReject: string;
  GetRawMaterialInwardRequests: string;
  updateRawMaterialInwardAccept: string;
  GetRawMaterialMovementLog: string;
  GetRawMaterialStockSummary: string;
  GetlastFiveOrders: string;
  GetManufacturingunitWiseRawMaterials: string;
  getvendorInvoiceforOilintakeEdit: string; GetTotalOrderValue: string;
  GetOrderByMe: string;
  GetOrderByOthers: string;
  getSupplyType: string;
  getSubSupplyType: string;
  getDocumentType: string;
  getTransportationMode: string;
  getConsignmentStatus: string;
  getModeOfGeneration: string;
  getEwayBillStatus: string;
  getCancellationReasonCodes: string;
  getVehicleType: string;
  getReasonForExtensionValidity: string;
  getTransactionTypes: string;
  generateEwayBill: string;
  GetExistingOpenOrders: string;
  GetoilproductionrecordExport: string;
  GetOrderdeliverySummary: string;
  viewOutwardChallan: string;
  getallBatches: string;
  getallbullsandoperatorbyposidanddate: string;
  getallbullsandoperatorbyid: string;
  SaveDeliveryInstruction: string;
  GetOrderInstructionsAndComments: string;
  getChallanDetails: string;
  getChallanDetailByNo: string;
  getDeliveryExecutivePerformanceRatio: string;
  fetchEwayBill: string;
  SaveQualityCheckResultsofRejected: string;
  GetPOSMovementsInwardDetailsList: string;
  GetRawMaterialPurchaseExport: string;
  UpdateDelayedStatus: string;
  GetRawmaterialReport: string;
  GetRawmaterialReportTotalInventory: string;
  GetRawmaterialReportExport: string;
  GetRawMaterialsByPosid: string;
  GetRawMaterialPurchaseHistory: string;
  getVesselDetailsByChallan: string;
  GetRawMaterialPurchaseHistoryExport: string;
  GetPOSMovementsSalesDetailsList: string;
  addOrderComment: string;
  GetAllVehicles: string;
  saveVehicle: string;
  getVehicleTypes: string;
  getVehicleById: string;
  updateVehicle: string;
  updateVehicleStatus: string;
  getPOSList: string;
  GetVehicleDropdown: string;
  getBullStatisticsMasterDataAsync:string;
  getBullStatisticsSummaryAsync:string;
  getproductwisePosOpenorderqty:string;
  SaveCustomerInstruction: string;
  GetCustomerInstruction: string;
}

const ApiConstant: ApiConstantModel = {
  canEditAddress: "/api/UserAddress/CanEditAddress/",
  FilterAssignRouteCodes: "/api/UserAddress/FilterAssignRouteCode",
  Assignroutecode2: "api/UserAddress/GetAssignRouteCode",
  userRegister: "/api/user",
  updateUser: "/api/user",
  getUser: "/api/user",
  getUserById: "/api/user/get/{0}",
  getCurrentUserDetails: "/api/user/GetUserDetail",
  changeUserPassword: "/api/User/ChangePassword",
  getToken: "/api/account/token",
  getRefreshToken: "/api/account/refresh",
  updateGPSLocation: "/api/UserAddress/UpdateGPSLocation/",
  updateGPSLocation1: "/api/UserAddress/UpdateGPSLocation1/",
  getHomeCategories: "/api/Home/GetHomeCategories/",
  getHomeProducts: "/api/Home/GetHomeProducts/",
  getHomeProducts1: "/api/Home/GetHomeProducts1/",
  getCategory: "/api/category",
  getSubCategory: "/api/subCategory",
  saveProduct: "/api/product",
  updateProduct: "/api/product/updateproductInfo",
  getAllAdminProducts: "/api/product",
  getProductPOSQuantity: "/api/pos/GetProductPOS",
  apiUserAddress: "/api/UserAddress?UserAdressId=",
  deleteProduct: "/api/product",
  getUserAddressById: "api/UserAddress/GetAllUserAddress?UserId=",
  getAreaAddressById: "/api/PincodeSearch/areaId",
  deleteUserAddress: "/api/UserAddress?userAddressID=",
  getCountries: "/api/Country/",
  getStatesByCounty: "/api/State/GetStatebyCountryID/",
  getCitiesByState: "/api/City/GetCitybyID/",
  sendForgotPasswordOTP: "/api/User/sendForgotPasswordOTP",
  sendRegistrationVerficationOTP: "/api/User/sendUserRegistrationOTP",
  getAllOrder: "/api/Order/GetAllOrder",
  getAllPOS: "/api/POS/GetAllPOS",
  getAllVendors: "/api/Vendor",
  createVendor: "/api/Vendor",
  updateVendor: "api/Vendor",
  deleteVendor: "/api/Vendor",
  getAllProducts: "/api/Product/GetAllProducts",
  getInvoiceUsers: "/api/User/GetInvoiceUserList/",
  resetPassword: "/api/User/resetpassword",
  validateOTP: "/api/User/ValidateOTP/",
  setCustomerOrder: "/api/Order",
  getOrderUserList: "/api/User/GetOrderUserList/",
  NewGetOrderUserList: "/api/User/FindOrderCustomers/",
  getRouteCodesApi: "/api/RouteCode/",
  saveRouteCodeApi: "/api/RouteCode/",
  deleteRouteCodeApi: "/api/RouteCode?routeCodeID=",
  sendUpdateUserOTP: "/api/User/SendUpdateUserOTP",
  getAllCourierProviders: "/api/CourierCharges",
  getRouteCodeUsers: "/api/UserAddress/GetAllUserAddress",
  updateUserRouteCode: "/api/UserAddress/UpdateAssignRouteCode",
  assignUserRouteCode: "/api/UserAddress/GetAssignRouteCode",
  getMyOrderList: "/api/Order",
  updateOrderStatus: "/api/Order/UpdateOrderStatus",
  generateNewInvoice: "/api/OrderInvoice",
  setAdminCustomerOrder: "/api/Order/CreateCustomerOrder",
  getAllUser: "/api/User/GetAllUser",
  updateUserDetail: "/api/User/UpdateOtherUserDetail",
  deleteUserDetail: "/api/User/DeleteOtherUser?userID=",
  getCustomerAddress: "/api/UserAddress/GetAllUserAddress",
  updateCustomerAddress: "/api/UserAddress/UpdateOtherUserAddress",
  createUser: "/api/User/CreateUser",
  apiAdminAddress: "/api/UserAddress/CreateOtherUserAddress",
  apiuserAddress: "/api/UserAddress/CreateUserAddress",
  apiAdminAddress2: "/api/UserAddress/CreateUserAddress",
  apiAdminAddress1: "/api/UserAddress/UpdateUserAddress",
  paymentInvoice: "/api/OrderInvoice/OrderInvoicePayment",
  othersPayment: "api/payments/CreateOrderPayment",
  changeOrderDeliveryDate: "/api/Order/UpdateOrderDeliveryDate",
  updatePendingQuantity: "/api/Order/UpdatePendingQuantity",
  getCountry: "/api/Country",
  getState: "/api/State",
  getCity: "/api/City",
  getReorderProductsByOrderId: "/api/Product/GetReorderProductsByOrderId/{0}",
  getAllCategory: "/api/Category",
  getAllSubCategory: "/api/SubCategory",
  pincodeSearch: "/api/PincodeSearch/Areas?pincode=",
  insertProductToInvoice: "/api/OrderInvoice/UpdateInvoiceProduct",
  updateUserAdressEdit: "api/UserAddress/UpdateUserAddressOnEdit",
  createOrderFormCustomer: "/api/Order/CreateOrderFromCustomer",
  createOrderForCustomer: "/api/Order/CreateOrderForCustomer",
  getNewUsersList: "api/User/GetNewUsersList",
  GetAllAddress: "/api/PincodeSearch/GetAllAddress?pageNumber=",
  FilterByUsersAddress: "/api/PincodeSearch/SearchFilter",
  orderDetails: "api/Order/OrderDetailsData",
  getAllOrderByOrderId: "/api/Order/GetAllOrderByOrderId",
  getorderExport: "api/Order/ExportOrderDetail",
  getOrderExportDetails: "api/Order/ExportReportOrderDetails",
  getInvoices: "api/Order/GetInvoice",
  getInvoicedetails: "api/Order/GetInvoiceDetails",
  addArea: "/api/PincodeSearch/createarea",
  getAllPincodeArea: "/api/PincodeSearch/GetAreas",
  searchFilterPincode: "/api/PincodeSearch/GetAllAreas",
  getAllCountryNames: "/api/PincodeSearch/GetAllCountryNames",
  getStatesByCountryID: "/api/PincodeSearch/GetStatesByCountryID/",
  getDistrictsByStateId: "/api/PincodeSearch/GetDistrictsByStateId/",
  getSubDistrictsByDistrictId: "/api/PincodeSearch/GetSubDistrictsByDistrictId/",
  addNewCountry: "/api/PincodeSearch/AddCountry",
  addNewState: "/api/PincodeSearch/AddState",
  addNewDistrict: "/api/PincodeSearch/AddDistrict",
  addNewSubDistrict: "/api/PincodeSearch/AddSubDistrict",
  GetAllCountries: "api/PincodeSearch/GetCountries",
  GetAllCountriesByFilter: "api/PincodeSearch/GetAllCountriesByfilter",
  UpdateCountries: "api/PincodeSearch/updatecountry",
  DeleteCountries: "api/PincodeSearch?countryId=",
  getMyOrderList1: "/api/Order/GetUserOrderHistory",
  getStates: "/api/PincodeSearch/GetStates",
  getAllStatesByfilter: "/api/PincodeSearch/GetAllStatesByfilter",
  updateState: "/api/PincodeSearch/UpdateState",
  deletestate: "/api/PincodeSearch/deletestate?stateId=",
  getDistricts: "/api/PincodeSearch/GetDistricts",
  searchStates: "/api/PincodeSearch/SearchStates",
  keywordSearchFilter: "/api/PincodeSearch/GetAllDistrictsByFilter",
  updatedistrict: "/api/PincodeSearch/updatedistrict",
  deleteDistrict: '/api/PincodeSearch/deletedistrict?districtId=',
  searchSubDistricts: "/api/PincodeSearch/SearchSubDistricts",
  updateAreaPincode: "/api/PincodeSearch/updatearea",
  deleteAreaPincode: "/api/PincodeSearch/deletearea",
  getUserDetailsComplaint: "api/User/GetOrderUserforComplaint?userId=",
  viewAllComplaints: "/api/Complaint/GetAllComplaints",
  saveComplaint: "api/Complaint/CreateComplaint",
  getComplaintType: "api/Complaint/GetComplaintType",
  deletecomplaintType: "/api/Complaint/DeleteComplaintType?complaintTypeId=",
  createComplaintType: "/api/Complaint/CreateComplaintType",
  updateComplaintType: "/api/Complaint/UpdateComplaintType",
  getAllStatus: "/api/Complaint/GetAllStatus",
  createComplaintStatus: "/api/Complaint/CreateComplaintStatus",
  UpdateComplaintStatus: "/api/Complaint/UpdateComplaintStatus",
  deletecomplaintStatusId: "/api/Complaint/DeleteStatus?complaintStatusId=",
  deleteComplaintCategory: "/api/Complaint/DeleteComplaintCategory?complaintCategoryId=",
  updateComplaintCategory: "/api/Complaint/UpdateComplaintCategory",
  createComplaintCategory: "/api/Complaint/CreateComplaintCategory",
  getComplaintCategory: "api/Complaint/GetComplaintCategory",
  getfilteredComplaints: "/api/Complaint/filtercomplaints",
  getUserInvoices: "api/Complaint/GetUserInvoices?userId=",
  getInvoicedproducts: "api/Complaint/GetInvoiceproducts?InvoiceNo=",
  getProductCategory: "api/Complaint/GetProductCategory?prouctID=",
  getAdminUserList: "api/Complaint/GetAdminList/",
  updateComplaint: "api/Complaint/UpdateComplaintInfo",
  getAdminDetailsComplaint: "api/Complaint/GetComplaintAdminList",
  getUserAllInvoices: "api/Complaint/GetUserAllInvoices?userId=",
  getUserAllInvoicesList: "api/Complaint/GetUserAllInvoicesList",
  getComplaintStatus: "api/Complaint/GetAllStatus",
  getCancelledOrders: "/api/Order/GetCanceledOrders",
  getSubDistricts: "/api/PincodeSearch/GetSubDistricts",
  getAllSubDistrictsByFilter: "api/PincodeSearch/GetAllSubDistrictsByFilter",
  createsubdistrict: "api/PincodeSearch/createsubdistrict",
  UpdateSubdistrict: "api/PincodeSearch/updatesubdistrict",
  DeleteSubdistrict: "api/PincodeSearch/deletesubdistrict?subDistrictId=",
  addNewSubDistrict1: "/api/PincodeSearch/createsubdistrict",
  getDirstics: "/api/PincodeSearch/SearchDistricts1",
  searchorders: "/api/Order/searchorders",
  saveOrderPacking: "/api/Order/save orderpacking",
  getPackingOrderByOrderId: "/api/Order/GetPackingOrderByOrderId",
  getOrderCities: "api/OrderInvoice/GetCitiesName",
  binOrderDetails: "api/OrderInvoice/GetAlldetailbybinfilter",
  invoiceDetails: "api/Order/InvoiceDetailData",
  getOrderInvoiceExportdetails: "api/Order/ExportReportInvoiceDetails",
  customerReport: "/api/Order/GetCustomerReport",
  getcustomerfollowup: "/api/AssignExecutives/CustomerFollowUP",
  getcallstatus: "/api/AssignExecutives/GetCallStatusName",
  savecallhistory: "api/AssignExecutives/CreateCallHistory",
  importDriverList: "api/Order/SaveOrderDelivery",
  importDriverList1: "api/Order/SaveOrderDelivery1",
  sendWhatsAppTemplateMessage: "/api/WhatsApp/send",
  getDeliveryOrders: "api/Order/GetDeliveryDetails",
  getDeliveredOrders: "api/Order/GetDeliverdDetails",
  cashCollectionReport: "api/Order/GetCollectionReport",
  getOpenOrderUserAddresses: "api/Order/GetOpenOrderUserAddresses",
  paymentLink: "api/Order/GetPaymentLinkInvoices",
  updateActualpayment: "api/Order/UpdateActuallPayment",
  cashandonline: "api/Order/GetIndividualcashCollectionReportAsync",
  getOrderAddressInfo: "api/Order/GetOrderAddressInfo/",
  getDriversList: "api/User/GetDriversList/",
  getAdminDeliveryDetails: "api/Order/GetAdminDeliveryDetails",
  getAdminDeliveredDetails: "api/Order/GetAdminDeliveredDetails",
  getDeliveryExecutives: "api/AssignExecutives/GetCustomerExecutiveList",
  getposproducts: "api/POS/GetPOSproducts",
  updateposproducts: "/api/POS/UpdatePosProduct",
  remainingposproducts: "/api/POS/GetRemainingPOSProducts",
  addposproducts: "/api/POS/AddPosProduct",
  GetOtherPOSStock: "/api/POS/GetOtherPOSStock?posId=&productId=",
  getinwardtypes: "/api/POS/GetInwardSoucetype",
  getallvendors: "/api/Vendor/GetallVendor",
  addinwardproduct: "/api/POS/AddPosInward",
  getadjusttypes: "/api/POS/GetAdjustSoucetype",
  Addadjustproduct: "/api/POS/AddPosAdjust",
  getoutwardtypes: "/api/POS/GetOutwardSourcetype",
  getremainingpos: "/api/POS/GetRemainingPOS?PosID=",
  addoutwardproduct: "/api/POS/AddPosOutward",
  getmovementlog: "/api/POS/GetPosStockMovements",
  addrequest: "/api/POS/Addrequest",
  getposrequest: "/api/POS/GetPosRequest",
  updatepossend: "/api/POS/Updateposrequestsend",
  updateposreject: "/api/POS/UpdateposReject",
  getpossummary: "/api/POS/GetPosStocksummary",
  getposinwardrequest: "/api/POS/GetPosInwardRequest",
  updateposinwardaccept: "/api/POS/UpdateposInwardrequestsend",
  updateposinwardreject: "/api/POS/UpdateposInwardReject",
  getOpenOrdersForMap: "api/Order/openordersformap",
  getGSTSalesReportsList: "api/Reports/GSTSalesReport",
  getGSTSalesReportsListExports: "api/Reports/GSTSalesReportExport",
  getChallanProducts: "api/Order/GetChallanProducts",
  createChallan: "api/Order/SaveChallan",
  GetCustomerExecutiveAssignments: "api/AssignExecutives/GetCustomerExecutiveAssignments",
  GetCustomerExecutiveList: "api/AssignExecutives/GetCustomerExecutiveList",
  UpdateCustomerExecutive: "api/AssignExecutives/UpdateCustomerExecutive",
  GenerateInvoiceDetails: "api/Order/GetPendingOrders",
  GetOrderByOrderIdForInvoice: "api/Order/GetAllOrderByOrderIdForInvoice",
  pullPaymentStatusLogs: "api/payments/PullPaymentStatusLogs",
  GetCustomerAssignedExecutive: "api/AssignExecutives/GetCustomerAssignedExecutive",
  getUserInvoicesAll: "/api/Complaint/GetUserInvoicesAll?userId=",
  InvoiceNumber: "/api/Complaint/InvoiceNumber?invoiceNo=",
  OrderInvoiceId: "/api/Complaint/OrderInvoiceId?orderInvoiceId=",
  CreateProductComplaint: "/api/Complaint/CreateProductComplaint",
  CreateServiceComplaint: "/api/Complaint/CreateServiceComplaint",
  CreateComplaintAction: "/api/Complaint/CreateComplaintAction",
  GetAllProductComplaints: "/api/Complaint/GetAllProductComplaints",
  GetAllServiceComplaints: "/api/Complaint/GetAllServiceComplaints",
  GetAllComplaintActions: "/api/Complaint/GetAllComplaintActions",
  getposproductdetails: "/api/POS/GetPOSproductdetails?posId=&productId=",
  getAllPOSBatch: "api/POS/GetAllPOSBatch",
  GetMUPlantName: "api/OilProduction/MUPlantName",
  GetMUPlantName1: "api/OilProduction/MUPlantName1",
  GetMUPlantNameById: "api/OilProduction/MUDetails",
  // getOilSeedNames: "api/OilProduction/GetAvailableOilSeeds",
  getAllOilSeedNames: "api/OilProduction/GetAllOilSeeds",
  // getVendorNames: "api/OilProduction/GetVendorsWithInvoicesByRawMaterial",
  //  getOilSeedNames: "api/OilProduction/availability/{posId}",
  //   getVendorNames: "api/OilProduction/invoices/{rawMaterialId}/{posId}",
  getOilSeedNames: "api/OilProduction/availability",
  getVendorNames: "api/OilProduction/invoices",
  getBullsAndOperatorsByPosId: "api/OilProduction/GetBullsAndOperatorsByPosId",
  addOilIntakeLog1: "api/OilProduction/AddOilIntakeLog",
  addOilIntakeLog: "api/OilProduction/SaveOilIntakeFull",
  editOilIntakeLogAPI: "api/OilProduction/UpdateOilProcessingOutput",
  AddOilProcessingOutputOnly: "api/OilProduction/AddOilProcessingOutputOnly",
  GetRolesByUserid: "/api/ManageAccess/GetUserRolesWithAssignmentStatus",
  Assigningtherole: "api/ManageAccess/CreateUserRoleMapping",
  CreateRole: "api/Role/CreateRole",
  GetAllRole: "api/Role/Getallrole",
  UpdateRole: "api/Role/UpdateRole",
  DeleteRole: "api/Role/DeleteRole?RoleID=",
  UpdateProductComplaintInfo: "/api/Complaint/UpdateProductComplaintInfo",
  UpdateServiceComplaintInfo: "/api/Complaint/UpdateServiceComplaintInfo",
  getAllBulls: "/api/OilProduction/GetAllDesiriBulls",
  getAllBullsForPairing: "/api/OilProduction/GetAllBullsForPairing",
  addBull: "/api/OilProduction/AddBull",
  getAllMUPlants: "/api/OilProduction/manufacturing-units-dropdown",
  getAllMUPlants1: "/api/OilProduction/manufacturingunitsdropdown",
  addGaana: "api/OilProduction/AddGaana",
  getAllGaanas: "api/OilProduction/GetAllGaana",
  getAllVendor: "/api/OilProduction/GetAllVendors",
  getAllDesignations: "/api/OilProduction/GetAllDesignation",
  addRole: "/api/OilProduction/AddDesignation",
  getAllUsers: "api/OilProduction/GetAllDesiriUsers",
  addUser: "/api/OilProduction/AddDesiriUser",
  getAllOilIntakeLogs: "/api/OilProduction/GetAllOilIntakeLogs",
  getAllOilIntakeLog: "/api/OilProduction/GetAllOilIntakeLog",
  getstage2AllOilIntakeLogs: "/api/OilProduction/Getstage2AllOilIntakeLogs",
  getCustomerDeliveryReport: "api/Order/GetCustomerDeliveryReport",
  getTestReportById: "/api/TestReport",
  GetVendorList: "api/RawMaterials/GetVendorList",
  GetRawMaterialCategory: "api/RawMaterials/GetRawMaterialCategory/",
  GetRawMaterials: "api/RawMaterials/GetRawMaterials",
  CreateRawMaterialPurchase: "/api/RawMaterials/CreateRawMaterialPurchase",
  GetRawMaterialMeasurementtype: "api/RawMaterials/GetRawMaterialMeasurementType/",
  GetAllDomain: "api/ManageAccess/GetAllDomains",
  GetAllFeatureByDomainID: "api/ManageAccess/FeaturesBYDomainID",
  GetFeatureByRoleID: "api/ManageAccess/FeatureAccessByRole",
  CreateandupdateFeatureMapping: "api/ManageAccess/UpsertFeatureAccess",
  getVesselDetails: "api/Order/GetVesselRequirements",
  GetPaymentOrderStatus: "api/payments/pullPaymentOrderStatus?OrderId=",
  CreateCustomerServiceComplaint: "/api/Complaint/CreateCustomerServiceComplaint",
  GetAllCustServiceComplaints: "/api/Complaint/GetAllCustServiceComplaints",
  UpdateCustServiceComplaintInfo: "/api/Complaint/UpdateCustServiceComplaintInfo",
  getPOSTargetMapping: "api/Reports/GetPOSTargetMappingList",
  updatePOSTargetMappingList: "api/Reports/UpdatePOSTargetMappingList",
  searchDelayStatus: "api/Order/GetDelayedStatus",
  saveDeliveryDelay: "api/Order/SaveDelayedStatus",
  getDelayedOrders: "api/Order/GetDelayedDetails",
  getAdminDelayedDetails: "api/Order/GetAdminDelayedDetails",
  CreateCustProductComplaint: "/api/Complaint/CreateCustProductComplaint",
  GetAllCustProductComplaints: "/api/Complaint/GetAllCustProductComplaints",
  UpdateCustProductComplaintInfo: "/api/Complaint/UpdateCustProductComplaintInfo",
  getAllUserSubscriptions: "/api/UserSubscriptions/GetUserSubscriptions",
  createUserSubscription: "/api/UserSubscriptions/CreateUserSubscritpions",
  updateUserSubscription: "/api/UserSubscriptions/UpdateUserSubscriptions",
  pauseUserSubscription: "/api/UserSubscriptions/{id}/PauseUserSubscriptions",
  resumeUserSubscription: "/api/UserSubscriptions/{id}/ResumeUserSubscriptions",
  deleteDesiriUser: "/api/OilProduction/DeleteDesiriUser",
  updateDesiriUser: "/api/OilProduction/UpdateDesiriUser",
  deleteDesiriBull: "/api/OilProduction/DeleteDesiriBull",
  updateDesiriBull: "/api/OilProduction/UpdateDesiriBull",
  deleteDesiriGaana: "/api/OilProduction/DeleteDesiriGaana",
  updateGaanaDetails: "/api/OilProduction/UpdateGaanaDetails",
  deleteDesiriRole: "/api/OilProduction/DeleteDesiriRole",
  updateDesiriRole: "/api/OilProduction/UpdateRole",
  getPOSInventoryReport: "api/POS/GetPOSInventoryReport? ",
  getPOSInventoryExcel: "api/POS/GetPOSInventoryExcel",
  getPOSTargetMappingMonthList: "api/Reports/GetPOSTargetMappingMonthList",
  GetDeliveryCashDetails: "/api/Deliverycash/GetCashTrack",
  GetusersListCashhandover: "/api/Deliverycash/GetUserListCashHandover",
  addCashHandoverrequest: "/api/Deliverycash/AddCashrequest",
  GetuserlistSearch: "/api/Deliverycash/GetUserListCashSearch",
  getAllPosProducts: "api/Product/GetAllProducts",
  getDeliveryAnalysis: "api/Order/GetDeliveryAnalysis",
  getAssignedOrdersDetails: "api/Order/GetAssignedOrdersDetails",
  getUndeliveredOrdersDetails: "api/Order/GetUndeliveredOrdersDetails",
  getDeliveredOrdersDetails: "api/Order/GetDeliveredOrdersDetails",
  updateOilIntakeLog: "/api/OilProduction/Update",
  GetRawMaterialPurchase: "/api/RawMaterials/GetRawMaterialPurchases",
  GetRMCategory: "api/RawMaterials/GetRMcategories",
  GetRawmaterialQualitycheck: "/api/RawMaterials/GetQualityChecksByPurchaseId/",
  SaveRawMaterialQCResult: "/api/RawMaterials/SaveQualityCheckResults",
  getProductwiseOrders: "api/Order/GetProductwiseOrders",
  testReportInit: "/api/TestReport/init",
  testReportHeaderById: "/api/TestReport/{0}/header",
  testReportHeaderLegacy: "/api/TestReport/header",
  testReportOilTypes: "/api/TestReport/oil-types",
  testReportBatchesByproduct: "/api/TestReport/batches/byproduct/{0}",
  testReportTolerances: "/api/TestReport/tolerances",
  testReportSearch: "/api/TestReport/search",
  testReportCalcPreviewById: "/api/TestReport/{0}/calculate-preview",
  testReportCalcSaveById: "/api/TestReport/{0}/calculate-and-save",
  testReportTemplate: "/api/TestReport/template",
  testReportCalcPreviewByProduct: "/api/TestReport/calculate-preview/by-product", // NEW
  testReportUpsert: "/api/TestReport/upsert",
  oilProdMUList: "/api/OilProduction/manufacturing-units-dropdown",
  oilProdOpsByPos: "/api/OilProduction/GetBullsAndOperatorsByPosId",
  testsFssai: "/tests/fssai",
  GetRMInvoiceNumbers: "api/RawMaterials/GetInvoiceNumbers",
  GetAllRawmaterial: "api/RawMaterials/GetAllRawMaterials",
  GetStoreandAcceptedcash: "/api/Deliverycash/GetCashTrackdetails",
  gethandoverrequests: "/api/Deliverycash/GetCashHandoverRequests",
  acceptcashhandover: "/api/Deliverycash/updateCashsettleAccept?Id=",
  rejectcashhandover: "/api/Deliverycash/updateCashsettleReject?Id=",
  CustomerExecutiveSalesReport1: "/api/AssignExecutives/CustomerExecutiveSales",
  CustomerExecutiveSalesReport2: "/api/AssignExecutives/CustomerSalesReport",
  CustomerExecutiveSalesReport3: "/api/AssignExecutives/InvoicedBySales",
  getOptimizedRoute: "api/Order/optimized-route",
  getDrivers: "api/Order/GetDrivers",
  createRawMaterial: "api/RawMaterials/CreateRawMaterial",
  UpdateRawMaterial: "api/RawMaterials/UpdateRawMaterial",
  deleteRawMaterial: "/api/RawMaterials/DeleteRawMaterial",
  GetAllRMMeasurementtype: "api/RawMaterials/GetAllMeasurementTypes",
  getAllHandoverRequestsHistory: "/api/Deliverycash/GetAllCashHandoverRequestsOfUsers",
  updateOilIntakeLog1: "/api/OilProduction/Edit",
  CreateInternalComplaint: "/api/Complaint/CreateInternalComplaint",
  CreateInternalComplaintAction: "/api/Complaint/CreateInternalComplaintAction",
  GetAllInternalComplaints: "/api/Complaint/GetAllInternalComplaints",
  UpdateInternalComplaint: "/api/Complaint/UpdateInternalComplaint",
  GetAllInternalComplaintAction: "/api/Complaint/GetAllInternalComplaintAction",
  testReportGetList: "/api/TestReport/GetTestReports",
  // POST: body { testIds: number[] }
  testReportChemsInstrLookup: "/api/TestReport/lookup/chems-instr",

  testReportOilTestersByPos: "/api/TestReport/testers/by-pos",
  GetAllRMcategories: "/api/RawMaterials/GetAllRMcategories",
  DeleteRawMaterialCategory: "/api/RawMaterials/DeleteRMCategory",
  CreateRawMaterialCategory: "api/RawMaterials/CreateRMCategory",
  UpdateRawMaterialCategory: "/api/RawMaterials/UpdateRMCategory",
  updateOilIntakeLog2: "/api/OilProduction/Stage2Edit",
  getSeedOilSummaryReport: "/api/OilProduction/GetoilproductionSummary",
  GetcashReport: "/api/Deliverycash/GetCashReport",
  getPreChallanProducts: "api/Order/GetPreChallanProducts",
  GetCETargetMappping: "/api/AssignExecutives/GetTargets",
  UpdateTarget: "/api/AssignExecutives/UpdateTarget",
  getAssignedCancelledOrdersDetails: "api/Order/GetAssignedCancelledOrdersDetails",
  GetAccountsCashDetails: "/api/Deliverycash/GetAccountsCash",
  getPOSOutwardChallan: "api/POS/GetPosOutwardChallan",
  generateOutwardChallan: "api/POS/GenerateChallan",
  GetReceivedCashTrace: "/api/Deliverycash/GetReceivedAmountTrace",
  GetHandovercashTrace: "/api/Deliverycash/GetHandoverAmountTrace",
  CardforCEReport: "/api/AssignExecutives/performance-report-card",
  CEPerformanceReport1: "/api/AssignExecutives/GetReport",
  GetStatusAnalysis: "/api/AssignExecutives/ce-call-status-pivot",
  GetCEDailyActivityTopcard: "/api/AssignExecutives/get-performance",
  GetCEDailyActivityStatusCards: "/api/AssignExecutives/summary",
  getDriverOrdersDailySummary: "/api/Order/daily-summary",
  GetManufacrturingunitlist: "/api/RawMaterials/GetMaufacturePOS",
  GetposRawmaterials: "/api/RawMaterials/GetPosRawMaterial?PosID=",
  GetRemainingposRawMaterials: "/api/RawMaterials/GetRemainingPOSRawMaterials?PosID=",
  AddposRawmaterials: "/api/RawMaterials/AddPosRawMaterials",
  UpdateposRawmaterials: "/api/RawMaterials/UpdatePosRawMaterials",
  GetalloutwardsourceType: "/api/RawMaterials/GetallOutwardSourcetype",
  GetRemainingMFPOS: "/api/RawMaterials/GetRemainingManufacturePOS?PosID=",
  GetVendorandInvoiceWiseQty: "/api/RawMaterials/GetvendorsAndInvoicewiseQty",
  AddRawMaterialOutward: "/api/RawMaterials/AddPosRawMaterialOutward",
  GetRMAdjustSourcetype: "/api/RawMaterials/GetRMAdjustSourcetype",
  AddRawMaterialAdjust: "/api/RawMaterials/AddPosRMAdjust",
  GetSummaryCardDetails: "/api/AssignExecutives/call-status-summary",
  GetDateWisecalldetails: "api/AssignExecutives/daily-report",
  GetUnassignedcustomers: "/api/AssignExecutives/unassigned",
  GetlastFiveOrders: "/api/AssignExecutives/LastOrders",
  AddRawMaterialRequest: "/api/RawMaterials/AddRawMaterialsrequest",
  GetRawMaterialOutwardRequests: "/api/RawMaterials/GetRawMaterialOutwardRequest?PosID=",
  updateRawMaterialRequestSend: "/api/RawMaterials/UpdateRawMaterialrequestsend",
  updateRawMaterialRequestReject: "/api/RawMaterials/UpdateRawMaterialOutwardReject",
  GetRawMaterialInwardRequests: "/api/RawMaterials/GetRawMaterialInwardRequest?PosID=",
  updateRawMaterialInwardAccept: "/api/RawMaterials/UpdateRawMaterialInwardSend",
  GetRawMaterialMovementLog: "/api/RawMaterials/GetRawMaterialStockMovements",
  GetRawMaterialStockSummary: "/api/RawMaterials/GetRawMaterialStocksummary",
  GetManufacturingunitWiseRawMaterials: "/api/OilProduction/GetManufactureUnitwiseRM?PosID=",
  getvendorInvoiceforOilintakeEdit: "/api/OilProduction/GetvendorsAndInvoicewiseQtyintake",
  //  GetlastFiveOrders: "/api/AssignExecutives/LastOrders",
  GetTotalOrderValue: "api/AssignExecutives/TotalOrderValue",
  GetOrderByMe: "/api/AssignExecutives/OrderByMe",
  GetOrderByOthers: "/api/AssignExecutives/orderByothers",
  getSupplyType: "api/Order/GetSupplyType",
  getSubSupplyType: "api/Order/GetSubSupplyType",
  getDocumentType: "api/Order/GetDocumentType",
  getTransportationMode: "api/Order/GetTransportationMode",
  getConsignmentStatus: "api/Order/GetConsignmentStatus",
  getModeOfGeneration: "api/Order/GetModeOfGeneration",
  getEwayBillStatus: "api/Order/GetEwayBillStatus",
  getCancellationReasonCodes: "api/Order/GetCancellationReasonCodes",
  getVehicleType: "api/Order/GetVehicleType",
  getReasonForExtensionValidity: "api/Order/GetReasonForExtensionValidity",
  getTransactionTypes: "api/Order/GetTransactionTypes",
  generateEwayBill: "api/Order/generate-ewb",
  GetoilproductionrecordExport: "/api/OilProduction/export",
  GetExistingOpenOrders: "/api/Order/GetExistingOpenorder",
  GetOrderdeliverySummary: "/api/Order/GetOrderDeliveryStatus",
  viewOutwardChallan: "api/POS/GetOutwardChallanProducts",
  getallBatches: "api/OilProduction/batch-timing/",
  getallbullsandoperatorbyposidanddate: "/api/OilProduction/get-bulls-operators-by-posid-and-submiteddate",
  getallbullsandoperatorbyid: "/api/OilProduction/GetBullsOperatorsByOilIntakeLogId",
  getDeliveryExecutivePerformanceRatio: "api/Deliverycash/delivery-performance",
  SaveDeliveryInstruction: "api/Order/SaveDeliveryInstruction",
  GetOrderInstructionsAndComments: "api/Order/GetOrderInstructionsAndComments",
  getChallanDetails: "api/Order/GetChallanDetails",
  getChallanDetailByNo: "api/Order/GetChallanProductDetails?challanNo=",
  fetchEwayBill: "api/Order/fetch-ewb",
  SaveQualityCheckResultsofRejected: "/api/RawMaterials/Save",
  GetPOSMovementsInwardDetailsList: "/api/POS/GetPOSMovementsInwardDetails",
  GetRawMaterialPurchaseExport: "/api/RawMaterials/GetRawMaterialPurchasesExport",
  UpdateDelayedStatus: "api/Order/UpdateDelayedStatus",
  GetRawmaterialReport: "/api/RawMaterials/GetRawMaterialPurchaseSummary",
  GetRawmaterialReportTotalInventory: "/api/RawMaterials/GetPosInventorySummary",
  GetRawmaterialReportExport: "/api/RawMaterials/GetRawMaterialPurchaseExcel",
  GetRawMaterialsByPosid: "/api/RawMaterials/GetRawMaterialsByPos",
  GetRawMaterialPurchaseHistory: "/api/RawMaterials/RawmaterialPurchaseHistory",
  getVesselDetailsByChallan: "api/Order/GetVesselRequirementsByChallan",
  GetRawMaterialPurchaseHistoryExport: "/api/RawMaterials/RawmaterialPurchaseHistoryExport",
  GetPOSMovementsSalesDetailsList: "/api/POS/GetPOSMovementsSalesDetailsAsync",
  addOrderComment: "api/Order/SaveOrderComment",
  GetAllVehicles: "api/Vehicle/GetAllVehicles",
  saveVehicle: "api/Vehicle/SaveVehicle",
  getVehicleTypes: "api/Vehicle/GetVehicleTypes",
  getVehicleById: "api/Vehicle/GetVehicleById",
  updateVehicle: "api/Vehicle/UpdateVehicle",
  updateVehicleStatus: "api/Vehicle/UpdateVehicleStatus",
  getPOSList: "api/Vehicle/GetPOSList",
  GetVehicleDropdown: "api/Vehicle/GetVehicleDropdown",
  getBullStatisticsMasterDataAsync:"api/OilProduction/GetBullStatisticsMasterDataAsync",
  getBullStatisticsSummaryAsync:"api/OilProduction/GetBullStatisticsSummaryAsync",
  getproductwisePosOpenorderqty:"api/POS/GetProductWiseOpenOrderQty",
  SaveCustomerInstruction: "api/Order/SaveCustomerInstruction",
  GetCustomerInstruction: "api/Order/GetCustomerInstruction",
};

export default ApiConstant;
